import styled from '@emotion/styled'

import { Button } from '../Button'
import { Flex } from '../Flex'

import { colors } from '@/constants'
import { useModal } from '@/hooks/useModal'
import { ModalFooterProps } from '@/typings/Modals'
import { mediaQuery } from '@/utils/mediaQuery'

const Wrapper = styled(Flex)`
  width: 100%;
  gap: 15px;
  justify-content: center;
  margin-top: 1.875rem;

  ${mediaQuery('sm')} {
    margin-top: 2.5rem;
  }
`

export default function ConfirmCancelModalFooter({
  type,
  onConfirm,
  cancelButtonText,
  confirmButtonText,
  isLoading,
}: ModalFooterProps) {
  const modal = useModal(type)

  return (
    <Wrapper>
      <Button
        style={{ backgroundColor: colors.darkBlue2 }}
        onClick={() => modal.close()}
        disabled={isLoading}
      >
        {cancelButtonText}
      </Button>
      <Button
        style={{ backgroundColor: colors.blue }}
        onClick={onConfirm}
        disabled={isLoading}
      >
        {isLoading ? 'Loading' : confirmButtonText}
      </Button>
    </Wrapper>
  )
}
